<div class="Customers overview-loyalty ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'store.panoramica_title' | translate}}</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>
    <kv-search-toolbar
            [dateBoxEnabled]="true"
            [date_structure]="searchModel.date_structure"
            [card_modes]="searchModel.card_modes"
            [clusters]="searchModel.cluster_list"
            [customersBoxEnabled]="false"
            [clusterFieldEnabled]="false"
            [selectedElapsedStart]="searchModel.selectedStartDate"
            [selectedElapsedEnd]="searchModel.selectedEndDate"
            [group_types]="searchModel.group_types"
            [groups]="searchModel.groups"
            [areas]="searchModel.areas"
            [stores]="searchModel.stores"
            [disableMutualExclusivity]="false"
            [storeSelectionMode]="'multiple'"
            [groupTypesFieldEnabled]="true"
            [storesBoxEnabled]="true"
            [storeFieldEnabled]="false"
            appQFilter
            (onQFilter)="ApplyResult($event)" #toolbar
    ></kv-search-toolbar>

    <div class="overview-container card ui-g-nopad">
      <app-shop-overview-main-kpi [hidden]="activeIndex !== 0" ></app-shop-overview-main-kpi>
      <app-elenco-pdv [hidden]="activeIndex !== 1" ></app-elenco-pdv>
      <app-shop-overview-trend [hidden]="activeIndex !== 2" ></app-shop-overview-trend>
      <app-list-customer-value [hidden]="activeIndex !== 3" ></app-list-customer-value>
    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/panoramica.component.html